module.exports = "https://portperrypedals.ca/_res/img/team.7568f67.jpg";